import { useEffect, useState } from 'react';
import {
  resolveAdviceMethodology,
  resolveAdviceScenarios,
  resolveAdviceWizardLayout,
  resolveUploadDocuments,
  subscribeAdviceWizardLayout,
} from '../services/adviceWizardLayoutSetting';

/**
 * Whether Recommendations and Amendments render the mirror layout for `email`,
 * whether the scenario tab strip shows, and whether Recommendations shows the
 * Methodology button, and whether the client pages show Upload documents
 * (see services/adviceWizardLayoutSetting.js). All off while loading.
 * Pass `enabled: false` until someone is signed in: a listener started before
 * sign-in errors and only recovers through the retry.
 */
export default function useAdviceWizardLayout(email, { enabled = true } = {}) {
  const [settings, setSettings] = useState(undefined);
  useEffect(() => {
    if (!enabled) return undefined;
    return subscribeAdviceWizardLayout(setSettings);
  }, [enabled]);
  return {
    mirror: resolveAdviceWizardLayout(settings, email),
    scenarios: resolveAdviceScenarios(settings, email),
    methodology: resolveAdviceMethodology(settings, email),
    uploadDocuments: resolveUploadDocuments(settings, email),
    loading: settings === undefined,
    settings: settings || null,
  };
}
